import { toast } from "react-toastify";
import { CLIENT_PLAN } from "../config/apiEndPoint";
import { GET, POST, PUT } from "config/api.config";

export const fetchClientPlanTableAndFilterSchema = async (data = {}) => {
  try {
    const response = await GET(CLIENT_PLAN.METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitFilterData = async (data = {}) => {
  try {
    const response = await POST(CLIENT_PLAN.FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addClientPlan = async (data = {}) => {
  try {
    const response = await POST(CLIENT_PLAN.LIST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateClientPlan = async (id, data = {}) => {
  try {
    const response = await PUT(CLIENT_PLAN.BY_ID(id), data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getClientPlanDataById = async (data = {}) => {
  try {
    const id = data?.Id ?? data?.id;
    const response = await GET(CLIENT_PLAN.BY_ID(id), data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
